module.exports = __webpack_public_path__ + "fonts/museo-sans-700-webfont.7863242.woff";